import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { FC } from 'react';

interface StatusCardsProps {
  count: number;
  countColor: string;
  isLoading: boolean;
  statusName: string;
}

const StatusCards: FC<StatusCardsProps> = ({
  count,
  countColor,
  isLoading,
  statusName,
}) => {
  return (
    <Stack
      gap={1.5}
      height={'100px'}
      minWidth={'250px'}
      p={2}
      sx={{
        background: '#FFFFFF',
        border: '1px solid #CCCCCC',
        borderRadius: '16px',
        boxShadow: '0px 0px 9px 2px #00000021',
      }}
    >
      <Typography sx={{ fontSize: '14px' }}>{statusName}</Typography>
      {isLoading ? (
        <CircularProgress size={30} sx={{ mx: '10px' }} />
      ) : (
        <Typography
          sx={{ color: countColor, fontSize: '28px', fontWeight: 500 }}
        >
          {count.toLocaleString()}
        </Typography>
      )}
    </Stack>
  );
};

export default StatusCards;
